<template>
  <div class="dropdown-search-wrap">
    <h4 class="text-block-title">
      {{ $t('CONTACT_PANEL.TOPICS.TOPIC_SELECT.TITLE') }}
    </h4>
    <div class="search-wrap">
      <input
        ref="searchbar"
        v-model="search"
        type="text"
        class="search-input"
        autofocus="true"
        :placeholder="$t('CONTACT_PANEL.TOPICS.TOPIC_SELECT.PLACEHOLDER')"
      />
    </div>
    <div class="list-wrap">
      <div class="list">
        <woot-dropdown-menu>
          <topic-label-dropdown-item
            v-for="topicLabel in filteredActiveTopicLabels"
            :key="topicLabel.title"
            :title="topicLabel.title"
            :color="topicLabel.color"
            :selected="selectedTopicLabels.includes(topicLabel.title)"
            @click="onAddRemove(topicLabel)"
          />
        </woot-dropdown-menu>
        <div v-if="noResult" class="no-result">
          {{ $t('CONTACT_PANEL.TOPICS.TOPIC_SELECT.NO_RESULT') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopicLabelDropdownItem from './TopicLabelDropdownItem';
export default {
  components: {
    TopicLabelDropdownItem,
  },

  props: {
    accountTopicLabels: {
      type: Array,
      default: () => [],
    },
    selectedTopicLabels: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      search: '',
    };
  },

  computed: {
    filteredActiveTopicLabels() {
      return this.accountTopicLabels.filter(topicLabel => {
        return topicLabel.title
          .toLowerCase()
          .includes(this.search.toLowerCase());
      });
    },

    noResult() {
      return this.filteredActiveTopicLabels.length === 0 && this.search !== '';
    },
  },

  mounted() {
    this.focusInput();
  },

  methods: {
    focusInput() {
      this.$refs.searchbar.focus();
    },

    updateTopicLabels(topicLabel) {
      this.$emit('update', topicLabel);
    },

    onAdd(topicLabel) {
      this.$emit('add', topicLabel);
    },

    onRemove(topicLabel) {
      this.$emit('remove', topicLabel);
    },

    onAddRemove(topicLabel) {
      if (this.selectedTopicLabels.includes(topicLabel.title)) {
        this.onRemove(topicLabel.title);
      } else {
        this.onAdd(topicLabel);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown-search-wrap {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 20rem;

  .search-wrap {
    margin-bottom: var(--space-small);
    flex: 0 0 auto;
    max-height: var(--space-large);

    .search-input {
      margin: 0;
      width: 100%;
      border: 1px solid transparent;
      height: var(--space-large);
      font-size: var(--font-size-small);
      padding: var(--space-small);
      background-color: var(--color-background);
    }

    input:focus {
      border: 1px solid var(--w-500);
    }
  }

  .list-wrap {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex: 1 1 auto;
    overflow: auto;

    .list {
      width: 100%;
    }

    .no-result {
      display: flex;
      justify-content: center;
      color: var(--s-700);
      padding: var(--space-smaller) var(--space-one);
      font-weight: var(--font-weight-medium);
      font-size: var(--font-size-small);
    }
  }
}
</style>

